import { Component, Input, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ScreenSizeService } from '@core/services';
import { fadeInOut } from '@shared/animations';
import { WidgetDetail } from '@shared/models';
import { UserContext } from '@core/models';

@Component({
  selector: 'sp-widget-grid',
  template: `
    <div class="widgets-container" [ngStyle]="{ height: height }">
      <ng-container *ngFor="let widget of widgets">
        <sp-widget
          *ngIf="widget.type"
          [widgetDetail]="widget"
          [evenVerticalGrid]="evenGrid"
          [userContext]="_userContext"
          [isMultipleCardPresent]="isMultipleCardPresent">
        </sp-widget>
      </ng-container>
    </div>
  `,
  styleUrls: ['./widgets-grid.component.scss'],
  animations: [fadeInOut],
})
export class WidgetsGridComponent implements OnInit {
  @Input() height: string;
  @Input() widgets: WidgetDetail[];
  @Input() evenGrid: boolean;
  @Input() showTaxImage = false;
  @Input() set userContext(val: UserContext) {
    this._userContext = val;
  }

  _userContext: UserContext;
  isMultipleCardPresent: boolean;

  ngOnInit(): void {
    if (this.widgets && this.widgets.length > 1) {
      this.isMultipleCardPresent = true;
    }
  }
}
